/**
 * SortDropdown — result sorting options.
 *
 * @param {Object} props
 * @param {string} props.value
 * @param {(key:string) => void} props.onChange
 */
import React from "react";
import "./sort-dropdown.css";

export const SORT_OPTIONS = [
  { key: "best", label: "Best" },
  { key: "cheapest", label: "Cheapest" },
  { key: "fastest", label: "Fastest" },
  { key: "earliest", label: "Earliest Departure" },
  { key: "latest", label: "Latest Departure" },
  { key: "lowest", label: "Lowest Price" },
  { key: "highest", label: "Highest Price" },
];

export default function SortDropdown({ value, onChange }) {
  return (
    <label className="sortdd">
      <span className="sortdd__label">Sort by</span>
      <span className="sortdd__select-wrap">
        <select
          className="sortdd__select"
          value={value}
          onChange={(e) => onChange(e.target.value)}
        >
          {SORT_OPTIONS.map((o) => (
            <option key={o.key} value={o.key}>
              {o.label}
            </option>
          ))}
        </select>
        <i className="fas fa-chevron-down sortdd__chevron" aria-hidden="true" />
      </span>
    </label>
  );
}
